import { createSelector } from 'reselect';
import _ from 'lodash';

const EMPTY_SETTINGS = {};

const getSettings = (state) => state.settings;

export const getGlobalSettings = createSelector([getSettings], (settings) => _.get(settings, 'global', EMPTY_SETTINGS));

export const getComponentSettings = createSelector([getSettings], (settings) =>
  _.get(settings, 'component', EMPTY_SETTINGS),
);
